import { Component, computed, input } from '@angular/core';
import { buildMultiDeviceGridColumns } from '@vectronic/util';

@Component({
  selector: 'vectronic-parameter-view-header',
  templateUrl: './parameter-view-header.component.html',
  styleUrl: './parameter-view-header.component.scss',
})
export class ParameterViewHeaderComponent {
  valueOverrideByParameterId = input<Map<string, Map<string, string>>>();
  columnWidth = input('180px');
  columnWidthByDeviceCount = input<Partial<Record<number, string>>>();

  columnTitles = computed<string[]>(() => {
    const map = this.valueOverrideByParameterId();
    if (!map?.size) return [];
    return Array.from(map.keys());
  });

  gridTemplateColumns = computed<string>(() => {
    const n = this.columnTitles().length;
    return buildMultiDeviceGridColumns(n, this.columnWidth(), this.columnWidthByDeviceCount());
  });
}
